require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-angular-part-3-10-resources.json") })
        }
      }, "path---blog-angular-part-3-10-resources");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-angular-part-3-10-resources!./.cache/json/blog-angular-part-3-10-resources.json
// module id = 589
// module chunks = 231608221292675